/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCategoryDto } from '../models/CreateCategoryDto';
import type { UpdateCategoryDto } from '../models/UpdateCategoryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CategoriesService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static categoriesControllerCreate(requestBody: CreateCategoryDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/categories',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all categories
   * @param page Page number
   * @param limit Items per page
   * @param searchName Search by category name
   * @param status Filter by status
   * @returns any Returns all categories
   * @throws ApiError
   */
  public static categoriesControllerFindAll(
    page?: number,
    limit?: number,
    searchName?: string,
    status?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/categories',
      query: {
        page: page,
        limit: limit,
        searchName: searchName,
        status: status,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static categoriesControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/categories/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static categoriesControllerUpdate(
    id: string,
    requestBody: UpdateCategoryDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/categories/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static categoriesControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/categories/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static categoriesControllerGetProductsByCategory(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/categories/{id}/products',
      path: {
        id: id,
      },
    });
  }
}
